import React from 'react'
import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components/DataTable'
import { priceDifference } from '../tableColumns'
import get from 'lodash/get'
import { withRouter } from 'react-router'
import { useTranslation } from 'react-i18next'

const Pricedifference = ({ data, history }) => {
	const [t] = useTranslation()
	const gotoProduct = (_, { original: closingPriceDifference }) => {
		const productId = get(closingPriceDifference, ['product', 'id'])
		if(productId) {
			history.push(`/artikel/${productId}`)
		}
	}
	return(
		<ContentBlock>
			<DataTable
				isInsideContentBlock
				label={t('closing_section.sub_sections.price_diff')}
				columns={priceDifference}
				data={data.priceDifference || []}
				onRowClick={gotoProduct}
			/>
		</ContentBlock>
	)
}

export default withRouter(Pricedifference)
